import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ResultDto } from '@/app/common/general-types/super-social.dto';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PhylloResultsService {
  private readonly http = inject(HttpClient);

  getLatestSubmittedPostArray(submittedPostIds: string[]) {
    return this.http.post<ResultDto[]>(
      `${environment.shout_api.url}/phyllo-results/latest-submitted-post-results`,
      { submittedPostIds },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }
}
